'use strict';

var i18n = window.i18n();

i18n.loadJSON({
    "": {
        "language": "de_DE",
        "plural-forms": "nplurals=2; plural=(n != 1);"
    },
    "Close": "Schließen",
    "A URL with the current filtering and selection has been copied to the clipboard.": "Die URL mit der aktuellen Filterung und Auswahl wurde in die Ablage kopiert.",
    "Copy URL": "URL kopieren",
    "day": [
        "Tag",
        "Tage"
    ],
    "hour": [
        "Stunde",
        "Stunden"
    ],
    "minute": [
        "Minute",
        "Minuten"
    ],
    "second": [
        "Sekunde",
        "Sekunden"
    ]
});
